export const companiesKeys = {
	all: ['companies'],
	byProspectQueryBase: (prospectQueryId) => ['companies', 'byProspectQuery', prospectQueryId],
	byProspectQuery: (prospectQueryId, { page, pageSize, orderBy, orderDir, filters = {} }) => [
		'companies',
		'byProspectQuery',
		prospectQueryId,
		page,
		pageSize,
		orderBy,
		orderDir,
		filters,
	],
	detail: (globalCompanyId) => ['companies', 'detail', globalCompanyId],
	financialHistory: (globalCompanyId) => ['companies', 'financialHistory', globalCompanyId],
	events: (globalCompanyId) => ['companies', 'events', globalCompanyId],
	contacts: (globalCompanyId) => ['companies', 'contacts', globalCompanyId],
	directors: (globalCompanyId) => ['companies', 'directors', globalCompanyId],
};

export const companiesMutationKeys = {
	update: ['companies', 'update'],
	delete: ['companies', 'delete'],
	enrich: ['companies', 'enrich'],
	addToQuery: ['companies', 'addToQuery'],
};
